import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { ICoverageMatrixResponse } from 'types/api/coverageApi.interface'
import { IShiftCoverageSiteSummary, IShiftCoverageSlice } from 'types/shiftCoverage.interface'
import { baseUrl } from 'utils/axios'
import { deriveCoverageWidgetSummary } from 'utils/coverageSummary'

const initialState: IShiftCoverageSlice = {
  isLoading: false,
  hasError: false,
  summaries: [],
}

export const getShiftCoverageSummary = createAsyncThunk(
  'shiftCoverage/getSummary',
  async (params: any, thunkAPI) => {
    try {
      const tree = (thunkAPI.getState() as any).locationRegistry?.tree
      const roots = !tree
        ? []
        : tree.id === 0 && Array.isArray(tree.children)
          ? tree.children
          : [tree]
      const date = params?.date || new Date().toISOString().slice(0, 10)
      const results: IShiftCoverageSiteSummary[] = await Promise.all(
        roots.map(async (root: any) => {
          const resp: AxiosResponse<ICoverageMatrixResponse> = await baseUrl.get('coverage/matrix', {
            params: { siteNodeId: root.id, date },
          })
          return { siteNodeId: Number(root.id), ...deriveCoverageWidgetSummary(resp.data) }
        }),
      )
      return results
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const shiftCoverageSlice = createSlice({
  name: 'shiftCoverage',
  initialState,
  reducers: {},
  extraReducers: {
    [getShiftCoverageSummary.pending.type]: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    [getShiftCoverageSummary.fulfilled.type]: (
      state: IShiftCoverageSlice,
      { payload }: { payload: IShiftCoverageSiteSummary[] },
    ) => {
      state.isLoading = false
      state.summaries = payload
    },
    [getShiftCoverageSummary.rejected.type]: (state) => {
      state.isLoading = false
      state.hasError = true
    },
  },
})

export default shiftCoverageSlice.reducer
